var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { Component } from "@theme/component";
import { onAnimationEnd } from "@theme/utilities";
import { ThemeEvents, CartUpdateEvent } from "@theme/events";
class CartIcon extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "requiredRefs", ["cartBubble", "cartBubbleText", "cartBubbleCount"]);
    /**
     * Handles the page show event when the page is restored from cache.
     * @param {PageTransitionEvent} event - The page show event.
     */
    __publicField(this, "onPageShow", (event) => {
      if (event.persisted) {
        this.ensureCartBubbleIsCorrect();
      }
    });
    /**
     * Handles the cart update event.
     * @param {CartUpdateEvent} event - The cart update event.
     */
    __publicField(this, "onCartUpdate", async (event) => {
      const itemCount = event.detail.data?.itemCount ?? 0;
      const comingFromProductForm = event.detail.data?.source === "product-form-component";
      this.renderCartBubble(itemCount, comingFromProductForm);
    });
    /**
     * Renders the cart bubble.
     * @param {number} itemCount - The number of items in the cart.
     * @param {boolean} comingFromProductForm - Whether the cart update is coming from the product form.
     */
    __publicField(this, "renderCartBubble", async (itemCount, comingFromProductForm, animate = true) => {
      this.refs.cartBubbleCount.classList.toggle("hidden", itemCount === 0);
      this.refs.cartBubble.classList.toggle("visually-hidden", itemCount === 0);
      this.currentCartCount = comingFromProductForm ? this.currentCartCount + itemCount : itemCount;
      this.classList.toggle("header-actions__cart-icon--has-cart", itemCount > 0);
      sessionStorage.setItem(
        "cart-count",
        JSON.stringify({
          value: String(this.currentCartCount),
          timestamp: Date.now()
        })
      );
      if (!animate || itemCount === 0) return;
      await new Promise((resolve) => requestAnimationFrame(resolve));
      this.refs.cartBubble.classList.add("cart-bubble--animating");
      await onAnimationEnd(this.refs.cartBubbleText);
      this.refs.cartBubble.classList.remove("cart-bubble--animating");
    });
    /**
     * Checks if the cart count is correct.
     */
    __publicField(this, "ensureCartBubbleIsCorrect", () => {
      if (!this.refs.cartBubbleCount) return;
      const sessionStorageCount = sessionStorage.getItem("cart-count");
      if (sessionStorageCount === null) return;
      const visibleCount = this.refs.cartBubbleCount.textContent;
      try {
        const { value, timestamp } = JSON.parse(sessionStorageCount);
        if (value === visibleCount) return;
        if (Date.now() - timestamp < 1e4) {
          const count = parseInt(value, 10);
          if (count >= 0) {
            this.renderCartBubble(count, false, false);
          }
        }
      } catch (_) {
      }
    });
  }
  /** @type {number} */
  get currentCartCount() {
    return parseInt(this.refs.cartBubbleCount.textContent ?? "0", 10);
  }
  set currentCartCount(value) {
    this.refs.cartBubbleCount.textContent = value < 100 ? String(value) : "";
  }
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.cartUpdate, this.onCartUpdate);
    window.addEventListener("pageshow", this.onPageShow);
    this.ensureCartBubbleIsCorrect();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.cartUpdate, this.onCartUpdate);
    window.removeEventListener("pageshow", this.onPageShow);
  }
}
if (!customElements.get("cart-icon")) {
  customElements.define("cart-icon", CartIcon);
}
